import { FRAUD_MODE_DETAIL } from '../../../../../routes/paths';
import { Table } from '../../../../components/general/table';
import { useFraudModeList } from './hook';
import { FraudModeListProps } from './props';

export const FraudModeList = ({ filters }: FraudModeListProps) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        useFraudModeList(filters);

    return (
        <Table
            columns={columns}
            rows={rows}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[2, 10, 20, 50]}
            disableRowSelectionOnClick
            onRowClick={(item) =>
                window.open(`${FRAUD_MODE_DETAIL}/${item.id}`, '_blank')
            }
        />
    );
};
